<app-cart-badge
  [numOfItems]="numOfItems | async"
  [badgeStyle]="badgeStyle"
  [badgeOffset]="badgeOffset"
></app-cart-badge>
